function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#filter0_f_7089_139231)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 105.105,
  r: 61,
  fill: "url(#paint0_linear_7089_139231)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 105.105,
  r: 61,
  fill: "white",
  fillOpacity: 0.2
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 94.1052,
  r: 50,
  fill: "white",
  fillOpacity: 0.06
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 94.1052,
  r: 50,
  stroke: "url(#paint1_linear_7089_139231)",
  strokeLinecap: "round",
  strokeDasharray: "4 4"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 94.1052,
  r: 50,
  stroke: "white",
  strokeOpacity: 0.8,
  strokeLinecap: "round",
  strokeDasharray: "4 4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M138.69 56C140.119 56 141.44 56.7624 142.154 58L161.845 92.1051C162.559 93.3427 162.559 94.8675 161.845 96.1051L142.154 130.21C141.44 131.448 140.119 132.21 138.69 132.21L99.309 132.21C97.88 132.21 96.5595 131.448 95.8449 130.21L76.1544 96.1051C75.4398 94.8675 75.4398 93.3427 76.1544 92.1051L95.8449 58C96.5595 56.7624 97.88 56 99.3091 56L138.69 56Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M136.826 84.6612H134.845L134.848 78.0789C134.848 69.2115 127.74 62 119.001 62C110.262 62 103.155 69.2119 103.155 78.0789V84.6612H101.173C97.7651 84.6612 95 87.4632 95 90.9244V115.751C95 119.208 97.7615 122.014 101.173 122.014H136.827C140.235 122.014 143 119.212 143 115.751V90.9216C143 87.464 140.238 84.662 136.827 84.662L136.826 84.6612ZM108.698 78.0789C108.698 72.3138 113.322 67.6259 119 67.6259C124.678 67.6259 129.302 72.3178 129.302 78.0789V84.6612H108.697L108.698 78.0789ZM122.159 105.128V108.729C122.159 110.498 120.747 111.93 119 111.93C117.257 111.93 115.845 110.498 115.845 108.729V105.128C114.365 104.103 113.398 102.381 113.398 100.429C113.398 97.2864 115.906 94.7409 119.004 94.7409C122.101 94.7409 124.61 97.2901 124.61 100.429C124.606 102.381 123.635 104.103 122.159 105.128Z",
  fill: "url(#paint2_linear_7089_139231)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M136.826 84.6612H134.845L134.848 78.0789C134.848 69.2115 127.74 62 119.001 62C110.262 62 103.155 69.2119 103.155 78.0789V84.6612H101.173C97.7651 84.6612 95 87.4632 95 90.9244V115.751C95 119.208 97.7615 122.014 101.173 122.014H136.827C140.235 122.014 143 119.212 143 115.751V90.9216C143 87.464 140.238 84.662 136.827 84.662L136.826 84.6612ZM108.698 78.0789C108.698 72.3138 113.322 67.6259 119 67.6259C124.678 67.6259 129.302 72.3178 129.302 78.0789V84.6612H108.697L108.698 78.0789ZM122.159 105.128V108.729C122.159 110.498 120.747 111.93 119 111.93C117.257 111.93 115.845 110.498 115.845 108.729V105.128C114.365 104.103 113.398 102.381 113.398 100.429C113.398 97.2864 115.906 94.7409 119.004 94.7409C122.101 94.7409 124.61 97.2901 124.61 100.429C124.606 102.381 123.635 104.103 122.159 105.128Z",
  fill: "white",
  fillOpacity: 0.2
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M226.261 48.0663C226.29 49.2327 226.319 50.4289 226.319 51.6262H226.32L226.323 51.8014C226.656 73.9088 227.11 104.022 190.454 116.779L190.43 116.787C190.109 116.893 189.784 117 189.46 117C189.131 117 188.798 116.891 188.465 116.779C151.717 103.993 152.27 73.7483 152.711 51.6262C152.824 49.2897 152.824 47.0662 152.824 44.8427V44.8426C152.824 43.062 154.263 41.7287 155.924 41.7287C169.094 41.7287 179.056 37.9507 187.358 29.8338C188.573 28.7221 190.453 28.7221 191.673 29.8338C199.975 37.9505 210.044 41.7287 223.107 41.7287C224.879 41.7287 226.207 43.1749 226.207 44.8426C226.207 45.8738 226.234 46.9566 226.261 48.0663ZM186.277 79.4188L201.119 62.6034L201.12 62.6044C201.898 61.7294 203.231 61.646 204.111 62.4146C204.986 63.1923 205.069 64.5303 204.296 65.4052L188.046 83.8076C187.671 84.2289 187.148 84.4835 186.587 84.5206C186.546 84.5252 186.499 84.5252 186.458 84.5252C185.944 84.5252 185.444 84.3354 185.055 83.9928L176.435 76.3678C175.56 75.5901 175.481 74.2521 176.254 73.3771C177.032 72.5021 178.374 72.4234 179.245 73.1965L186.277 79.4188Z",
  fill: "white",
  fillOpacity: 0.06
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.229 104.552C55.0994 102.516 49.5757 101.452 43.9965 101.452C32.2709 101.452 21.2414 106.088 12.9405 114.504C4.67553 122.884 0.0836887 134.015 0.00976868 145.848L0 147.437L1.37113 148.222C7.97923 152.008 15.4522 154 23.0248 154C23.2331 154 23.4429 153.998 23.6517 153.995C30.2526 153.899 36.7832 152.301 42.7038 149.351C40.8368 148.3 39.0478 147.116 37.3472 145.81C27.0278 149.903 15.3323 149.399 5.4347 144.272C6.39742 123.509 23.3745 106.876 43.9965 106.876C49.7323 106.876 55.3978 108.154 60.5141 110.581C60.5801 108.571 60.4859 106.556 60.229 104.552Z",
  fill: "white",
  fillOpacity: 0.06
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M87.9833 145.479C87.8266 130.769 80.7127 117.347 68.8538 109.171C68.8626 111.324 68.7201 113.475 68.4262 115.614C76.853 122.542 81.9896 132.743 82.5519 143.919C64.3755 153.35 41.7076 146.746 31.3821 128.724C28.5932 123.856 26.8833 118.413 26.3807 112.852C24.6265 113.815 22.951 114.924 21.3693 116.166C22.2034 121.518 24.0158 126.715 26.7206 131.436C32.5942 141.687 42.0376 149.038 53.3095 152.131C57.134 153.18 61.0218 153.7 64.8894 153.7C72.4231 153.7 79.8776 151.729 86.6219 147.866L88 147.076L87.9833 145.479Z",
  fill: "white",
  fillOpacity: 0.06
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.5514 70.803L44.1918 70L42.8322 70.8018C36.1138 74.7608 30.5323 80.437 26.6906 87.2162C23.3732 93.0709 21.4109 99.6293 20.9508 106.324C22.7899 105.223 24.7058 104.255 26.6869 103.428C28.3935 92.3923 34.7667 82.4184 44.1892 76.3236C61.4953 87.5286 67.1871 110.761 56.7917 128.904C53.9766 133.818 50.1274 138.066 45.5673 141.328C47.2701 142.374 49.0591 143.281 50.9177 144.041C55.1329 140.599 58.7224 136.383 61.453 131.616C73.59 110.433 66.4567 83.1524 45.5514 70.803Z",
  fill: "white",
  fillOpacity: 0.06
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.1646 117.09C41.6856 117.09 39.6687 119.123 39.6687 121.621C39.6687 124.119 41.6856 126.152 44.1646 126.152C46.6444 126.152 48.6614 124.119 48.6614 121.621C48.6614 119.123 46.6444 117.09 44.1646 117.09ZM44.1646 131.576C38.7174 131.576 34.2861 127.11 34.2861 121.621C34.2861 116.132 38.7174 111.666 44.1646 111.666C49.6126 111.666 54.0443 116.132 54.0443 121.621C54.0443 127.11 49.6126 131.576 44.1646 131.576Z",
  fill: "white",
  fillOpacity: 0.06
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_7089_139231",
  x: 3,
  y: 0.10498,
  width: 210,
  height: 210,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 22,
  result: "effect1_foregroundBlur_7089_139231"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_7089_139231",
  x1: 169,
  y1: 105.105,
  x2: 47,
  y2: 105.105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_7089_139231",
  x1: 169,
  y1: 94.1053,
  x2: 69,
  y2: 94.1053,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_7089_139231",
  x1: 143,
  y1: 92.007,
  x2: 95,
  y2: 92.007,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})));

function SvgGateway(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 211,
    viewBox: "0 0 227 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateway);
export default __webpack_public_path__ + "static/media/Gateway.67f08019d0c8b2c3c5fdcf1124e43ac5.svg";
export { ForwardRef as ReactComponent };